import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/basic-info/supplier-list`;

export const supplierListRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:supplierId`,
} as const;

export type ISupplierListRouteParams = IExtractRouteParamMap<
  typeof supplierListRoutesObj
>;

export const supplierListPath = createPaths<
  typeof supplierListRoutesObj,
  ISupplierListRouteParams
>(supplierListRoutesObj);
